<template>
  <v-container>
    <v-col class="demand-view">
      <v-row>
        <v-data-table
          class="demands-view__table"
          :headers="headers"
          :items="project.demand_fulfillments"
          hide-default-footer
          sort-by="created_on"
            @click:row="showDemandFulfillment"
        >
          <template v-slot:item.created_on="{ item }">
            <span>{{ new Date(item.created_on).toLocaleString() }}</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon medium color="grey">
                    mdi-dots-horizontal
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(elem, i) in context_menu"
                  :key="i"
                  @click="elem.action(item)"
                >
                  <v-list-item-title>{{ elem.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
    </v-row>
    <v-row>
      <td width="25px"></td>
      <td width="350px">
        <span @click="showNewDemandFulfillmentDialog(null)">
          <v-btn slot="prepend" small fab icon :elevation="6" style="color:white !important; background-color:#67B3D9;" class="ma-2">
            <v-icon >
              mdi-plus
            </v-icon>
          </v-btn>
          <span >{{ $t('demandView.button') }}</span>
        </span>
      </td>
    </v-row>
    <new-demand-fulfillment-dialog 
      :visible="showNewDialog"
      @close="showNewDialog = false"/>
      </v-col>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store/index";
import NewDemandFulfillmentDialog from '../components/dialogs/NewDemandFulfillmentDialog.vue';

export default {
  name: "DemandsView",

  components: { NewDemandFulfillmentDialog },

  data() {
    return {
      context_menu: [
        { title: this.$i18n.t('contextMenu.duplicate'), action: function(item) {store.commit('addNewDemandFulfillment', item)} },

        {
          title: this.$i18n.t('contextMenu.remove'),
          action: async function(item) {
            let confirm = await this.comp.$confirm(
              `${this.comp.$i18n.t('demandView.dialog.subtext1')} "${item.name}" ${this.comp.$i18n.t('demandView.dialog.subtext2')}`,
                {
                  color: "#2F6C86",
                  title: this.comp.$i18n.t('demandView.dialog.title'),
                  icon: "mdi-delete",
                  buttonTrueText: this.comp.$i18n.t('demandView.dialog.buttonTrue'),
                  buttonFalseText: this.comp.$i18n.t('demandView.dialog.buttonFalse'),
                }
              );

              if (confirm) {
                this.comp.$store.dispatch('removeDemandFulfillment', item);
              }
            },
        },
      ],
      
      
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: this.$i18n.t('demandView.date'), value: 'created_on' },
        { text: '', value: 'actions', sortable: false },
      ],

      showNewDialog: false
    }
  },

  computed: {
    ...mapState(['project','projects', 'regions']),
  },

  mounted() {
    // store a reference to the component in each menu entry in order to be able to call methods on the component instance
    this.context_menu.forEach(m => m.comp = this)
  },

  methods: {
    showNewDemandFulfillmentDialog(val) {
      if (!val) {
        this.showNewDialog = true;
      }
    },

    showDemandFulfillment(item,row) {
      store.commit('setDemandFulfillment', row.index);
      this.$router.push({ 
        path: "" + row.index
      });
    },
  },
    
};
</script>
